import { useEffect } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { authService } from '../../services/auth.service';

/**
 * Manages user idle timeout and automatic logout
 * Logs out user after 30 minutes of inactivity
 *
 */
export const IdleTimerManager = () => {
  const onIdle = () => {
    authService.logout();
  };

  const { getRemainingTime } = useIdleTimer({
    onIdle,
    timeout: 30 * 60 * 1000, // 30 minutes
    throttle: 500
  });

  useEffect(() => {
    // Component mounted - idle timer is active
    return () => {
      // Component unmounted - idle timer is cleaned up
    };
  }, []);

  return null;
};
